<div class="mb-4">
  <ziro-collapsible-section-card
    [isSwitchHidden]="true"
    [removeExpandedClass]="true"
    [title]="'tkey;teams_call_queue.audio_settings.header'"
    [icon]="ziroIcons.ANNOUNCEMENTS"
    [isCollapsible]="false"
  >
    <div class="d-flex p-4 gap-4">
      <div class="d-flex flex-column w-100">
        <ziro-radio class="flex-grow-1" [fieldId]="'greetingType'"></ziro-radio>
        <div [hidden]="entity.greetingType !== GreetingType.CUSTOM_GREETING">
          <ziro-file-upload #greeting [fieldId]="'greetingUpload'"></ziro-file-upload>
          @if (!isGreetingLoading() && entity.greetingUpload && acceptedFileTypes.includes(greetingFileExtension())) {
            <audio
              [attr.data-automation]="'greeting-audio'"
              class="mt-2 w-100"
              controls
              [src]="greetingUploadURL()"
              [title]="greetingDownloadName()"
            ></audio>
          }
          <p class="mb-0 font-size-12">{{ 'tkey;teams_call_queue.audio_settings.audio_file.info' | translate }}</p>
        </div>
        <ziro-textarea
          [fieldId]="'greetingTtsMessage'"
          [hidden]="entity.greetingType !== GreetingType.TTS_MESSAGE"
        ></ziro-textarea>
      </div>
      <div class="d-flex flex-column w-100">
        <ziro-radio class="flex-grow-1" [fieldId]="'musicOnHoldType'"></ziro-radio>
        <div [hidden]="entity.musicOnHoldType !== MusicOnHoldType.CUSTOM_MUSIC">
          <ziro-file-upload [fieldId]="'musicOnHoldUpload'"></ziro-file-upload>
          @if (
            !isMusicOnHoldLoading() &&
            entity.musicOnHoldUpload &&
            acceptedFileTypes.includes(musicOnHoldFileExtension())
          ) {
            <audio
              [attr.data-automation]="'moh-audio'"
              class="mt-2 w-100"
              controls
              [src]="musicOnHoldUploadURL()"
              [title]="musicOnHoldDownloadName()"
            ></audio>
          }
          <p class="mb-0 font-size-12">{{ 'tkey;teams_call_queue.audio_settings.audio_file.info' | translate }}</p>
        </div>
      </div>
    </div>
  </ziro-collapsible-section-card>
</div>
